/**
 * What an alerts list shows, reduced to whether a reload changed it. Both the
 * web bell and the native Alerts tab back their polls off on this, so a
 * renamed row or a moved timestamp does not count as news.
 */
import type { Notification } from '../types/notifications';

export function notificationSnapshotKey(rows: readonly Pick<Notification, 'id' | 'read'>[], unreadCount: number | null): string {
  return `${unreadCount}|${rows.map(row => `${row.id}:${row.read ? 1 : 0}`).join(',')}`;
}
